const opened = require('./opened');
const closed = require('./closed');

module.exports = { opened, closed };
